namespace TabAurous.Stock {
    export namespace OwnStoneStockService {
        export const baseUrl = 'Stock/OwnStoneStock';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Stock/OwnStoneStock/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>OwnStoneStockService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
